
















































import Vue from "vue";
import router from "@/router";
import identityAuthenClient from "@/services/identityAuthenClient";
import allCountries from "@/modules/vuetifyx/utils/all-countries";
import SignOut from "../partials/SignOut.vue";
import RequestUnlock from "@/constant/request-unlock";

export default Vue.extend({
  name: "ForgotPassword",
  components: { SignOut },
  data() {
    return {
      itemsCode: [],
      form: false,
      error: "",
      inputData: "",
      isWaiting: false
    };
  },
  mounted() {
    if (this.$route.query) {
      this.inputData = this.$route.query.loginName;
    }
  },
  methods: {
    goBack() {
      router.push("/login");
    },

    async onRequestUnlock() {
      this.isWaiting = true;
      const params = {
        login_name: this.inputData,
        type: RequestUnlock[0]
      };
      try {
        let data = await identityAuthenClient.requestUnlock(params);
        if (data) {
          if (data.error_info && data.error_info.error_code) {
            this.error = data.error_info.message;
            return;
          }
          data.login_name = params.login_name;
          data = btoa(unescape(encodeURIComponent(JSON.stringify(data))));
          await this.$router.push({
            name: "request-unlock-otp",
            query: data
          });
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.isWaiting = false;
      }
    },
    preventReload(event) {
      event.preventDefault();
    }
  },
  created() {
    if (allCountries.length > 0) {
      this.itemsCode = allCountries.map(country => country[2]);
    }
  }
});
